import { render, staticRenderFns } from "./SaveReportWizard.vue?vue&type=template&id=47badd06"
import script from "./SaveReportWizard.vue?vue&type=script&lang=js"
export * from "./SaveReportWizard.vue?vue&type=script&lang=js"
import style0 from "./SaveReportWizard.vue?vue&type=style&index=0&id=47badd06&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports